/**
 * Created by shem.mahluf on 28/08/2016.
 */
import initialState from '../store/initialstate';
import C from '../constants/toolbox';

export default (state = initialState().toolbox, action = null) => {
    switch(action.type){
        case C.GET_TOOLBOX_LIST:
            if (action.payload == ''){
                action.payload = [];
            }
            return state.set(C.TOOLBOX_LIST, action.payload);
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./reducers/toolbox.js